import { useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBalanceAndPin } from "../../features/balance-and-pin/balanceAndPinSlice";
import { formattedBalance } from "../../features/balance-and-pin/utils";
import Spinner from "../../components/Spinner";

import logo from "./img/logo.png";
import welcome from "./img/welcome.webp";
import jacket from "./img/jacket.webp";
import glod from "./img/glod.png";
import reiss from "./img/reiss-logo.svg";
import boboLogo from "./img/bobo-logo.svg";
import copyIcon from "./img/copy-icon.svg";
import digiseq from "./img/digiseq-logo.png";
import paymeswiss from "./img/paymeswiss-logo.svg";
import openLink from "./img/open-link.svg";
import checkmarkCircle from "./img/checkmark-circle.svg";
import copyIconWhite from "../../assets/copy-icon-white.svg";
import videoThumbnail from "./img/videothumb.png";

import packageJson from "../../../package.json";

import {
  MainContainer,
  Navbar,
  WelcomeSection,
  IntroSection,
  PersonalSection,
  MyJacketSection,
  PaymentSection,
  Footer
} from "./styles";

const AustrianGp25 = () => {
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get("serialNumber");
  const [copied, setCopied] = useState(null);
  const [isMounted, setIsMounted] = useState(false);

  const dispatch = useDispatch();

  const { balanceAndPin, isLoading } = useSelector(
    (state) => state.balanceAndPin
  );

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
    };
  }, []);

  useEffect(() => {
    if (isMounted) {
      setTimeout(() => {
        setCopied(null);
      }, 2000);
    }
  }, [copied, isMounted]);

  useEffect(() => {
    if (!balanceAndPin && serialNumber) {
      dispatch(
        getBalanceAndPin({
          serial: serialNumber,
          query: "?provider=pannovate"
        })
      );
    }
  }, [balanceAndPin, serialNumber, dispatch]);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <MainContainer>
        <Navbar>
          <img src={logo} alt="logo" />
        </Navbar>
        <WelcomeSection>
          <img src={welcome} alt="welcome" />
          <h1>{"Welcome, Lukas Bayer"}</h1>
          {/* <p className="caption">Bahrain Grand Prix, 2025</p> */}
        </WelcomeSection>
        <IntroSection>
          <h2>Congratulations</h2>

          <p>
            You’re now the proud owner of a truly one-of-a-kind jacket - brought
            to life by Mastercard. Designed from the race-day memories of
            McLaren Formula 1 Team fans and transformed by GLOD into wearable
            art, this priceless piece goes beyond fashion.
          </p>
          <p>
            With the integrated NFC chip, your jacket is also a contactless
            payment device, combining technology, storytelling, and style in one
            seamless experience.
          </p>
        </IntroSection>
        <PersonalSection>
          <h2>This One is Personal</h2>
          <div className="video-container">
            <video
              src="https://s3.eu-west-2.amazonaws.com/www.digiseq.co.uk/mastercard/mclaren.mp4"
              playsInline
              preload="auto"
              controls
              poster={videoThumbnail}
            />
          </div>
        </PersonalSection>

        <MyJacketSection>
          <h2>My Mastercard Jacket</h2>
          <p>Reiss x McLaren Formula 1 Team Leather Jacket</p>
          <div className="inner-container">
            <div className="jacket-section">
              <img src={jacket} alt="jacket" />
            </div>
            <div className="details-section">
              <div className="details-item">
                <div className="reiss-logo">
                  <img src={reiss} alt="reiss" />
                </div>
                <p>Designed by</p>
                <img src={glod} alt="glod" />
                <p>Serial number: 1/1</p>
              </div>

              <div className="primary-button">
                <p>Certified Authentic</p>
                <img src={checkmarkCircle} alt="authentic" />
              </div>
            </div>
          </div>
        </MyJacketSection>

        <PaymentSection>
          <div className="intro">
            <h2>Papaya-powered. Payment Ready.</h2>
            <p>Pay contactless with your smart Reiss jacket!</p>
          </div>
          <div className="balance">
            <div className="balance-amount">
              <p>
                Remaining Balance:{" "}
                {balanceAndPin?.balanceDetails?.availableBalance
                  ? formattedBalance(
                      balanceAndPin?.balanceDetails?.availableBalance,
                      balanceAndPin?.balanceDetails?.currency,
                      true
                    )
                  : "N/A"}
              </p>
            </div>
          </div>
          <div className="bobo-container">
            <img className="bobo-logo" src={boboLogo} alt="bobobank" />
            <p>
              Want to continue enjoying unrivaled payment experience? Upgrade to
              Bourgeois Bohème wallet!
            </p>
            <p>Your jacket activation code</p>
            <div className="activation-code">
              {copied === "from-bobo" ? (
                <p className="copied">Copied to clipboard</p>
              ) : (
                <p>
                  {balanceAndPin?.activationCode
                    ? balanceAndPin?.activationCode
                    : "N/A"}
                </p>
              )}
              <img
                className="copy-icon"
                src={copyIcon}
                alt="copy"
                onClick={() => {
                  if (!balanceAndPin?.activationCode) return;
                  navigator.clipboard.writeText(balanceAndPin?.activationCode);
                  setCopied("from-bobo");
                  setTimeout(() => {
                    setCopied(null);
                  }, 2000);
                }}
              />
            </div>
            <div
              className="join-button"
              onClick={() =>
                window.open(
                  `https://events.bobofin.com/?token=${balanceAndPin?.activationCode}`,
                  "_blank"
                )
              }
            >
              <p>Join Bourgeois Bohème</p>
              <img src={openLink} alt="open-link" />
            </div>
          </div>
        </PaymentSection>

        <Footer>
          <p className="powered-by">Powered by</p>
          <img
            className="digiseq"
            src={digiseq}
            alt="digiseq"
            onClick={() => window.open("https://www.digiseq.co.uk", "_blank")}
          />
          <p className="payment-services">Payment services by</p>
          <img
            className="paymeswiss"
            src={paymeswiss}
            alt="paymeswiss"
            onClick={() => window.open("https://paymeswiss.com/", "_blank")}
          />

          {serialNumber && (
            <div className="copyToClipboard">
              <p>ID: {serialNumber}</p>
              <img
                onClick={() => {
                  navigator.clipboard.writeText(serialNumber);
                  setCopied("from-footer");
                }}
                src={copyIconWhite}
                alt="copy to clipboard"
              />
            </div>
          )}
          {copied === "from-footer" && (
            <p>
              <b>Copied to clipboard</b>
            </p>
          )}
          <div className="version">
            <p>v.{packageJson.version}</p>
          </div>
        </Footer>
      </MainContainer>
    </>
  );
};

export default AustrianGp25;
